// extracted by mini-css-extract-plugin
export default {"Separator":"Separator_Separator__Kf5UF","spin":"Separator_spin__-ZUU9"};